import { useNavigate } from 'react-router-dom';
import { useMutation } from "@apollo/client";
import { ORGANIZER_UPDATE, ORGANIZER_CREATE } from "graphql/mutation/organizer-gql";
import OrganizerConst from '../organizer-const';
import { successNotification, errorNotification } from "components/request-result";



const useMutationOrganizerCreateUpdate = (id: string | undefined, redirect = true) => {

  const navigate = useNavigate();

  const ORGANIZER_CREATE_UPDATE = id ? ORGANIZER_UPDATE : ORGANIZER_CREATE;
  const organizerCreateUpdate = id ? 'organizerUpdate' : 'organizerCreate';

  const [ _setOrganizerCreateUpdate, { loading } ] = useMutation(ORGANIZER_CREATE_UPDATE,
    {
      update(cache, { data }) {

        const {
          [ organizerCreateUpdate ]: {
            label,
            message,
          }
        } = data;


        redirect && navigate(OrganizerConst.basePath);

        successNotification({
          title: label,
          description: message
        });
      },
      onError(error) {
        errorNotification(error);
      }
    }
  );


  return {
    _setOrganizerCreateUpdate,
    loadingMutationOrganizerCreateUpdate: loading,
  };
};

export default useMutationOrganizerCreateUpdate;

